import SearchFilter from '@components/ui/search-filter/search-filter';

import { useUrlFilter } from '@/hooks';

import { ResetFilterButton } from '../../../components/ui/button';

export const SupplierListFilters = () => {
    const { setSearchText, searchText } = useUrlFilter();
    return (
        <div className="grid w-full grid-cols-[minmax(0,1fr)_auto] items-center gap-2 sm:flex">
            <div className="min-w-0 sm:w-[300px] [&_input]:!w-full">
                <SearchFilter
                    placeholder={'Search suppliers'}
                    onChangeSearch={(e) => setSearchText(e.target.value)}
                    value={searchText}
                />
            </div>
            <div className="[&_button]:size-10 sm:[&_button]:size-9">
                <ResetFilterButton />
            </div>
        </div>
    );
};

SupplierListFilters.displayName = 'SupplierListFilters';
